import { coreOrganizationsLinkPostAsyncSlice } from './post';

export const {
	requestPostCoreOrganizationsLink,
	resetPostCoreOrganizationsLink
} = coreOrganizationsLinkPostAsyncSlice.asyncActionCreators;
